import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { page } from '../class/status';

@Component({
    selector: 'app-high-risk-churn',
    templateUrl: './high-risk-churn.component.html',
    styleUrls: ['./high-risk-churn.component.css']
})
export class HighRiskChurnComponent implements OnInit {

    loading: boolean = false;
    data: any[] = [];
    sort_obj: any = { column: 'total_score', sort: '1' };
    pageobj: page = { page: 0, count: 20, total_count: 0 };
    pageobjstr: string = JSON.parse(JSON.stringify(this.pageobj));
    tool_obj: any = { search_model: '' };

    tcontent = [
        { title: '用戶名稱', content: 'name', type: 2 },
        { title: '頭像', content: 'profile_pic', type: 1 },
        { title: '風險分數', content: 'total_score', type: 3, sort: 'total_score' },
        { title: '登入分數', content: 'login_score', sort: 'login_score' },
        { title: '消費分數', content: 'consume_score', sort: 'consume_score' },
        { title: '儲值分數', content: 'deposit_score', sort: 'deposit_score' },
        { title: '最後上線日期', content: 'last_singin_date', sort: 'last_singin_date' },
        { title: '手機', content: 'phone_num' },
        { title: '資料建立時間', content: 'create_dt', sort: 'create_dt' },
        { title: '帳號建立時間', content: 'user_create_dt', sort: 'user_create_dt' },
    ];

    constructor(public httpClient: HttpClient) {}

    ngOnInit(): void {
        this.init_list();
    }

    init_list() {
        this.loading = true;
        const body = {
            page: this.pageobj.page,
            count: this.pageobj.count,
            sort_obj: this.sort_obj,
            tool: this.tool_obj,
        };
        this.httpClient.post<any>('/v1/data_analyze/lost_users.php', body).subscribe(res => {
            this.loading = false;
            if (res.status) {
                this.data = res.data;
                this.pageobj.total_count = res.total_count;
            } else {
                this.data = [];
                this.pageobj.total_count = 0;
            }
            this.pageobjstr = JSON.parse(JSON.stringify(this.pageobj));
        }, error => {
            this.loading = false;
            console.log(error);
        });
    }

    handlesortdata(value: any): void {
        this.sort_obj = value;
        this.pageobj.page = 0;
        this.init_list();
    }

    callback(pageobj: page) {
        if (JSON.stringify(this.pageobj) !== JSON.stringify(pageobj)) {
            this.pageobj = pageobj;
            this.init_list();
        }
    }
}
